import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
      <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
      {items.map((it, i) => (
        <li key={i} className="flex items-center gap-1.5">
          <ChevronRight className="h-3 w-3 text-line" />
          {it.to && i < items.length - 1 ? (
            <Link to={it.to} className="hover:text-gold transition-colors">{it.name}</Link>
          ) : (
            <span className="text-palm font-medium">{it.name}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;
